import React from 'react';
import { HighSchoolOurTeamsCardFragment } from '../../../generated/spin-graphql';
import { gql } from '@urql/core';
import { TeamCard } from './TeamCard';

type Props = {
    highSchool: HighSchoolOurTeamsCardFragment;
};

gql`
    fragment HighSchoolOurTeamsCard on espin_high_school {
        bio
        contact_email
        contact_name
        name
        teams(where: { team_type: { _eq: school }, deleted_at: { _is_null: true } }) {
            ...TeamCard
        }
        ...HighSchoolProfileInfo
    }
`;

export const HighSchoolOurTeamsCard: React.FC<Props> = ({ highSchool }) => {
    return (
        <div className="high-school-our-teams-card">
            <h2 className="title">Our Teams</h2>
            {highSchool.teams.length === 0 && <div>No Teams</div>}
            {highSchool.teams.length > 0 && (
                <div className="our-teams-container">
                    {highSchool.teams.map((team) => (
                        <TeamCard
                            key={`team-$${team.id}`}
                            game={team.game.game_definition}
                            gameName={team.game.name}
                            teamName={team.display_name}
                            teamMembers={team.members}
                        />
                    ))}
                </div>
            )}
        </div>
    );
};
